import gql from 'graphql-tag'

export const GET_TOPIC_GROUP = gql`
  query GetTopicGroup($ProgramId: String!) {
    getTopicGroup(ProgramId: $ProgramId) {
      TopicLPID
      ProductName
    }
  }
`
